import axios from "axios";
import API from "../_helpers/endpointService";

export const getprojectsocdocinfo = (id) => {
  let apiUrl = API.STATEMENTOFCOMPLETION + "?ProjectId=" + id;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "SOC_LISTVIEW", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const gethistorylogSOC = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=StatementOfCompletion'
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const geteditsocdocinfo = (id) => {
  let apiUrl = API.STATEMENTOFCOMPLETION + '/' + id
  return (dispatch) => {
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "SOCEDIT_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          // logOut();
        }
      });
  };
};
export const filedeletesoc = (id, filename, modify) => {
  let apiUrl = API.STATEMENTOFCOMPLETION + '/' + id + '?filename=' + filename + '&modify=' + modify;
  return (dispatch) => {
    axios({
      method: "DELETE",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};